import { getAssignmentHashKey } from '@components/status-cell/helpers';

export const mapUnassignAssignmentHashKeys = (requestData = []) =>
  requestData.map(({ learningJourneyId, studentUserProfileId }) =>
    getAssignmentHashKey(studentUserProfileId, learningJourneyId)
  );

export const generateUnassignedAssignment = ({ learningJourneyId, assignmentId, studentUserProfileId }) => ({
  learningJourneyId,
  assignmentId,
  studentUserProfileId
});

export const ASSIGN_DATE_MODAL_ID = 6;
export const UNASSIGN_WARNING_MODAL_ID = 7;

export default mapUnassignAssignmentHashKeys;
